import { Inject, Injectable } from "@angular/core";
import { Socket } from "ngx-socket-io";
import { SOCKET_URL } from "./constants";


@Injectable({providedIn: 'root'})
export class SocketService extends Socket {
    constructor(@Inject(SOCKET_URL) socketUrl: string) {
        super({ url: socketUrl, options: {transports: [ "websocket" ], withCredentials: true}});
    }
}